<template><div><h1 id="auftragsposition-archiviert" tabindex="-1"><a class="header-anchor" href="#auftragsposition-archiviert"><span>Auftragsposition, archiviert</span></a></h1>
<p>Auftragsposition, archiviert — Eine archivierte Position in einem Auftrag</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Um die Fakturierung nicht unnötig zu belasten, werden alte, abgeschlossene Aufträge aus dem System ausgelagert. Dies geschieht mittels regelmässig laufender Hintergrundjobs.</p>
<p>In den archivierten Auftragspositionen sind der Umfang der Lieferung (Artikel), die Versandkosten und allfällige Spenden zum <RouteLink to="/referenz/refs/ft.refdata.auftraghist.html" title="Auftrag, archiviert">archivierten Auftrag</RouteLink> definiert.</p>
<p>Pfad: <code v-pre>Verkauf → Aufträge (archivierte)</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Pos.</dt>
<dd>Auftragspositionsnummer; wird vom System vergeben.</dd>
<dt>Artikel</dt>
<dd>Artikelnummer, aus <a class="link" href="ft.refdata.artikel.html" title="Artikel">Artikel</a>.</dd>
<dt>Medium</dt>
<dd>Das <a class="link" href="ft.refdata.tblmedium.html" title="Medium">Medium</a>, aus dem der Artikel bestellt wurde. Das Medium definiert, welche Response- Ereignisse für den Auftrag generiert werden.</dd>
<dt>Anzahl</dt>
<dd>Auftragsmenge</dd>
<dt>Artikelbezeichnung</dt>
<dd>Bezeichnung aus <a class="link" href="ft.refdata.artikel.html" title="Artikel">Artikel</a> (nur Anzeige).</dd>
<dt>Preis/Stk</dt>
<dd>Einzelpreis des Artikels aus <a class="link" href="ft.refdata.artikel.html" title="Artikel">Artikel</a>.</dd>
<dt>- %</dt>
<dd>Rabatt in Prozent, der für die Auftragsposition gezogen wird, siehe im Detail <a class="link" href="../../manual/trade/rabattstufen.html" title="9. Rabattstufen einrichten">Rabattstufen</a></dd>
<dt>Total</dt>
<dd>Gesamtpreis der Auftragsposition</dd>
<dt>Faktura</dt>
<dd>Fakturanummer</dd>
<dt>Status</dt>
<dd>Auftragspositionsstatus:
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>vorreserviert</td>
<td>Artikel ist ist nicht an Lager. Bei Einlagerung wird er zu einem reservierten Artikel und kann geliefert werden.</td>
</tr>
<tr>
<td>reserviert</td>
<td>der Artikel ist verfügbar und für diesen Auftrag reserviert</td>
</tr>
<tr>
<td>vorreserviert VZ</td>
<td>Vorauszahlung, vorreserviert</td>
</tr>
<tr>
<td>reserviert VZ</td>
<td>Vorauszahlung, reserviert</td>
</tr>
<tr>
<td>intern geliefert</td>
<td>geliefert, fakturiert aus eigenem Lager</td>
</tr>
<tr>
<td>extern geliefert</td>
<td>geliefert, fakturiert aus externem Lager (Direktlieferant)</td>
</tr>
<tr>
<td>retourniert</td>
<td>Der Artikel ist vom Kunden retourniert worden</td>
</tr>
<tr>
<td>abgesagt</td>
<td>z.B. ausverkaufter Artikel, abgesagt durch Avisierungssystem oder wegen nicht bezahlter Vorauszahlung</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>keine</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.auftraghist.html" title="Auftrag, archiviert">Auftrag archiviert</RouteLink>, <RouteLink to="/manual/trade/auftragsverwaltung.html#Auftragsverwaltung" title="1. Auftragsverwaltung">Auftragsverwaltung</RouteLink></p>
</div></template>


